export default "__VITE_ASSET__b4f2a663__"